
import { EnumBisogniActions } from './bisogni_actions';
//import update from 'react-addons-update';
import update from 'immutability-helper';

const EnumActions = EnumBisogniActions;

const initialState = {

    listaBisogni: [],

}



const bisogni = (state, action) => {
    if (typeof state === 'undefined') {
        return initialState
    }

    let moduleName = "[BisogniReducer.js]"
    switch (action.type) {

        case EnumBisogniActions.INITIALIZED:
            return initialState
        case EnumBisogniActions.LIST_BISOGNI:
            return Object.assign({}, state, { listaBisogni: action.dati })

        
        default:
            return state;
    }
}

export default bisogni;